export default __webpack_public_path__ + "media/collab_opportunity1_icon.25c297e9e842e5837198cad0f3cec903.svg";